import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/app/LandingPageClient.tsx");
